import React, { type ReactNode, useContext, useCallback } from 'react'

import { type DrawerOpenOptions } from '../DrawerOpenOptions'
import { DrawersContext } from '../DrawersProvider'

export function useDrawer(drawer?: ReactNode, options?: DrawerOpenOptions) {
  const { openDrawer: openDrawerContext, closeDrawer: closeDrawerContext } =
    useContext(DrawersContext)

  const openDrawer = useCallback(
    () => openDrawerContext(drawer, options),
    [drawer, options]
  )
  const closeDrawer = () => closeDrawerContext()

  return { openDrawer, closeDrawer }
}
